import { cn } from '@/helpers/classnames';

export const Skeleton = () => {
  return (
    <div className="max-w-sm animate-pulse">
      <SkeletonBar className="mb-4 h-2.5 w-48" />
      <SkeletonBar className="mb-2.5 h-2 max-w-[360px]" />
      <SkeletonBar className="mb-2.5 h-2" />
      <SkeletonBar className="mb-2.5 h-2 max-w-[330px]" />
      <SkeletonBar className="mb-2.5 h-2 max-w-[300px]" />
      <SkeletonBar className="h-2 max-w-[360px]" />
    </div>
  );
};

interface SkeletonBarProps {
  className?: string;
}

const SkeletonBar = ({ className }: SkeletonBarProps) => {
  return <div className={cn('rounded-full bg-background-200', className)} />;
};
